export const invitationsKeys = {
  all: [{ module: 'invitations' }] as const,
  details: () => [{ ...invitationsKeys.all[0], scope: 'detail' }] as const,
  detail: (invitationId: string) => [{ ...invitationsKeys.details()[0], invitationId }] as const,
};
